export const removeTimestampSuffix = (
  idWithTimestamp: string | undefined,
): string | undefined =>
  !(idWithTimestamp && idWithTimestamp.includes(':'))
    ? idWithTimestamp
    : idWithTimestamp?.split(':').slice(0, -1).join(':') || undefined;
